export const MARKETING_PLUS_SUITE = 'MARKETING_PLUS_SUITE';
export const CRM_SUITE = 'CRM_SUITE';
export const NONE = 'NONE';